import React, { PropsWithChildren } from "react";

type FormContextType = {
  inputValue: string;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
};

const FormContext = React.createContext<FormContextType>({
  inputValue: "",
  setInputValue: () => {},
});

const FormContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [inputValue, setInputValue] = React.useState<string>("");

  return (
    <FormContext.Provider
      value={{
        inputValue,
        setInputValue,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};

const useFormContext = () => React.useContext(FormContext);

export { FormContext, FormContextProvider, useFormContext };
